// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__rBz-O","tab--hover":"Tab_tab--hover__VlzES","tab--selected-background":"Tab_tab--selected-background__xzIky"};